import { render } from "./StandardCard.vue?vue&type=template&id=74430e87"
import script from "./StandardCard.vue?vue&type=script&lang=js"
export * from "./StandardCard.vue?vue&type=script&lang=js"

import "./StandardCard.vue?vue&type=style&index=0&id=74430e87&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__